export const API_STATUSES = {
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const VALID_CONTENT_TYPES = {
  date: 'date',
  imageUpload: 'imageUpload',
  fileUpload: 'fileUpload',
  navigationLink: 'navigationLink',
  radio: 'radio',
  select: 'select',
  textInput: 'textInput',
  textArea: 'textArea',
  textContent: 'textContent',
  img: 'img',
  video: 'video',
};

export const CONTENT_TYPE_CATEGORIES = {
  INPUT: 'input',
  TEXT_CONTENT: 'textContent',
  MEDIA: 'media',
};

export const TEXT_CATEGORY_MAPPING = {
  h3: 'h4',
  h4: 'h5',
  body: 'p',
  bodyLabel: 'p',
  caption: 'p',
  captionLabel: 'p',
};

export const TROUBLESHOOTING_TYPES = {
  SOLAR: 'SOLAR',
  POWERWALL: 'POWERWALL',
  WALL_CONNECTOR: 'WALL_CONNECTOR',
};

export const ISSUE_CATEGORIES = {
  WALL_CONNECTOR: 'vehicleCharging',
};

export const ISSUE_SUBCATEGORIES = {
  default: {
    ACCOUNT: 'accountBilling',
    SOLAR: 'maintenanceTroubleshooting',
    POWERWALL: 'powerwallMaintenanceTroubleshooting',
    WALL_CONNECTOR: 'homeCharging',
    REMOVAL_AND_REINSTALLATION: 'solarPanelRemoval',
    SCHEDULING: 'energyScheduling',
  },
  en_AU: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  en_HK: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  en_MO: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  en_NZ: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  en_TH: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  th_TH: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  zh_HK: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  zh_MO: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
  zh_TW: {
    WALL_CONNECTOR: 'homeChargingInstallation',
  },
};

export const CONTACT_US_DETAILS_MAPPING = {
  buyerOwnershipTransfer: {
    chat: false,
    email: true,
    hideEmailWhenChatAvail: false,
    categoryCode: 'TCC-SYS-ECS-51',
    symptomCode: '11132020',
  },
  suddenDropInPerformance: {
    chat: false,
    email: true,
    hideEmailWhenChatAvail: false,
    categoryCode: 'TCC-SYS-ECS-51',
    symptomCode: '10982020',
  },
  gradualDropInPerformance: {
    chat: false,
    email: true,
    hideEmailWhenChatAvail: false,
    categoryCode: 'TCC-SYS-ECS-51',
    symptomCode: '10982020',
  },
  highUtilityBill: {
    chat: false,
    email: true,
    hideEmailWhenChatAvail: false,
    categoryCode: 'TCC-SYS-ECS-51',
    symptomCode: '10962020',
  },
  systemNotProducingEnough: {
    chat: false,
    email: true,
    hideEmailWhenChatAvail: false,
    categoryCode: 'TCC-SYS-ECS-51',
    symptomCode: '10982020',
  },
  energyScheduling: {
    chat: true,
    email: true,
    hideEmailWhenChatAvail: true,
    symptomCode: '11150628794',
  },
  energySchedulingChat: {
    chat: true,
    email: false,
  },
  roofReplacement: {
    chat: true,
    email: true,
    categoryCode: 'TCC-SYS-ECS-48',
    symptomCode: '10542020',
  },
  removalAndReinstallation: {
    chat: true,
    email: true,
    hideEmailWhenChatAvail: true,
    symptomCode: '10542020',
  },
  homeRemodel: {
    chat: false,
    email: true,
  },
  solarAgreementBuyout: {
    chat: false,
    email: true,
    categoryCode: 'TCC-SYS-ECS-51',
    symptomCode: '10282020',
  },
};

export const FILE_DISPLAY_NAME_MAX_LENGTH = 38;
